import { Button, Center, Stack, Title } from '@mantine/core';
import { useIsFirstRender } from '@mantine/hooks';
import { IconDeviceFloppy } from '@tabler/icons-react';
import { i18nKeys } from 'locales/index';
import { useTranslation } from 'locales/logic';
import { AnimatePresence, motion } from 'motion/react';

import { useAutomationWizardController } from '../controller';

import { ActionCard } from './ActionCard/ActionCard';
import { AddButton } from './AddButton';
import { GROW_IN_AND_OUT_ANIMATION_PROPS } from './Step3';

export const Step4 = () => {
  const { t } = useTranslation();
  const {
    automation,
    navigation: { isStep4Valid, isCreateAutomationLoading, handleSave },
  } = useAutomationWizardController();

  const isFirstRender = useIsFirstRender();

  return (
    <Center mt="md">
      <Stack gap={0}>
        <Title order={5} mb="lg">
          {t(i18nKeys.AUTOMATION.WIZARD.STEP4.TITLE)}
        </Title>
        <AnimatePresence>
          {automation.actions.map((_, index) => (
            <motion.div key={index} {...(isFirstRender ? {} : GROW_IN_AND_OUT_ANIMATION_PROPS)}>
              <ActionCard actionIndex={index} />
            </motion.div>
          ))}
        </AnimatePresence>
        <AddButton />
        <Button
          w="100%"
          mt="lg"
          disabled={!isStep4Valid()}
          leftSection={<IconDeviceFloppy stroke={1.5} size={20} />}
          onClick={handleSave}
          loading={isCreateAutomationLoading}
        >
          {t(i18nKeys.AUTOMATION.WIZARD.STEP4.SAVE)}
        </Button>
      </Stack>
    </Center>
  );
};
